

<template>
<div class="row">
    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
        <div id="map" class="min-h-50"></div>
    </div>
    <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
        <div class="col-md-12 ml-sm-0 col-lg-12 pt-1 px-1 pl-5 green_line">
            <table class="table">
                <thead>
                    <th>{{ trans.get('common.name') }}</th>
                    <th>{{ trans.get('common.zone_type') }}</th>
                    <th>{{ trans.get('common.longitude') }}</th>
                    <th>{{ trans.get('common.latitude') }}</th>
                </thead>
                <tbody>
                    <tr v-for="z in zoneTable" :key='z["nom"]'>
                        <td>{{z["nom"]}}</td>
                        <td>{{z["name"]}}</td>
                        <td>{{z["longitude"]}}</td>
                        <td>{{z["latitude"]}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="add!=true" class="col-md-12 ml-sm-0 col-lg-12 pt-1 px-1 pl-5">
            <div class = "row mx-0 green_line">
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{ trans.get('common.zone_type') }}</h5>
                </div>
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <div class="form-group">
                        <select name='type' class="form-control" v-model='zone[nbZone-1]["name"]' @change="updateQuestionsQuestionnaire()">
                            <option disabled value="">{{ trans.get('common.choose') }}</option>
                            <option>Roof</option>
                            <option>Parking</option>
                            <option>Ground</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class ="row mx-0">
                <h6 class="colorText">{{ trans.get('common.move_marker_to_building') }}</h6>
            </div>
            <div class="row mx-0">
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{ trans.get('common.latitude') }} :</h5>
                </div>
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <input type="text" :id ='"latitude"+zone[nbZone-1]["nom"]' class="nonInput pl-5" disabled="disabled" v-model='zone[nbZone-1]["latitude"]'/>
                </div>
            </div>

            <div class="row mx-0 green_line pb-2">
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{ trans.get('common.longitude') }} :</h5>
                </div>
                <div class ="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <input type="text" :id ='"longitude"+zone[nbZone-1]["nom"]' class="nonInput pl-5" disabled="disabled" v-model='zone[nbZone-1]["longitude"]'/>
                </div>
            </div>
            <div v-if='zone[nbZone-1]["name"]=="Roof" && PVReady==1'>
                <div class="row mx-0 mt-2">
                    <h6 class="colorText">{{ trans.get('common.fill_form') }}</h6>
                </div>
                <div class="input-group green_line pb-2" v-for="n in questions.next" :key="n.id" > 
                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                        <div class = "row mx-0">
                            <h6 v-if='n.type=="Question"' style="margin-bottom: 0px;">{{n.intitule}}</h6> <!--Question-->
                        </div>
                        <div class ="row mx-0" v-for="o in n.next" :key="o.id">
                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                <div class ="row mx-0 buttonOriginal2"> 
                                    <input type="radio" class="buttonOriginal3 mx-3 my-3" :id="o.intitule" :name="n.intitule" :value="o.intitule"  v-model="n.selection" >
                                    <h5 class="my-0 py-3" :for="o.intitule">{{o.intitule}}</h5>
                                </div>
                                <div class="row mx-0" v-if="n.selection==o.intitule && o.next.length>0">
                                    <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                        <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                    </div>

                                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1"> 
                                        <div v-for="p in o.next" :key="p.id">
                                            <div class="row mx-0 py-3 " >
                                                <h6 v-if='p.type=="Question"' style="margin-bottom: 0px;">{{p.intitule}}</h6> <!--Question-->
                                            </div>
                                            <div class ="row mx-0 " v-for="q in p.next" :key="q.id">
                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <div class ="row mx-0 buttonOriginal2"> 
                                                        <input type="radio" class =" buttonOriginal3 mx-3 my-3" :id="q.intitule" :name="p.intitule" :value="q.intitule"  v-model="p.selection" >
                                                        <h5 class="my-0 py-3" :for="q.intitule">{{q.intitule}}</h5>
                                                    </div>
                                                    <div v-for="r in p.next" :key="r.id">
                                                        <div class="row form-inline" v-if="p.selection==r.intitule && r.next.length>0">

                                                            <div class="col-md-1 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                            </div>
                                                        
                                                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                                                                <div v-for= "r in q.next" :key="r.id">

                                                                    <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                                                                        <h6 v-if='r.type=="Question"' style="margin-bottom: 0px;">{{r.intitule}}</h6> <!--Question-->
                                                                    </div>
                                                                    <select v-model ="r.selection" class="btn btn-default dropdown-toggle">
                                                                        <option v-for= "s in r.next" :key="s.id">{{s.intitule}}</option>
                                                                    </select>

                                                                    <div v-for="s in r.next" :key="s.id">
                                                                        <div class="row form-inline" v-if="r.selection==s.intitule && s.next.length>0">

                                                                            <div class="col-md-1 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                                <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                                            </div>
                                                                            
                                                                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                                                                                <div v-for= "t in s.next" :key="t.id">

                                                                                    <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                                                                                        <h6 v-if='t.type=="Question"' style="margin-bottom: 0px;">{{t.intitule}}</h6> <!--Question-->
                                                                                    </div>
                                                                                    <select v-model ="t.selection" class="btn btn-default dropdown-toggle">
                                                                                        <option v-for= "u in t.next" :key="u.id">{{u.intitule}}</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <div class ="row mx-0">
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='saveZone()' :title="trans.get('common.save')">
                        <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                    </button>
                </div>
                <div class="col-md-10 ml-sm-0 col-lg-10 pt-1 px-1 pl-5">
                    <div class ="row mx-0">
                        <input name="data" type="hidden" id="data" style="visibility:hidden" >
                        <h5 class="colorText">{{ trans.get('common.save_zone') }}</h5>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="add==true" class="col-md-12 ml-sm-0 col-lg-12 pt-1 px-1 pl-5"> 
            <div class ="row mx-0 ">
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='addZone()' :title="trans.get('common.add')">
                        <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                    </button>
                </div>
                <div class="col-md-10 ml-sm-0 col-lg-10 pt-1 px-1 pl-5">
                    <div class ="row mx-0">
                        <h5 class="colorText">{{ trans.get('common.new_zone') }}</h5>
                        <a class="infobulle" href="#">
                            <span class="glyphicon glyphicon-question-sign" aria-hidden="true" style="color: white !important; font-size : 15px ">
                                <span>{{ trans.get('common.zone_info') }}</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script >
    export default {
        props : ['site', 'pvready', 'formulaire', 'formulaireParking', 'zoneexistant', "token"],     
        data : function(){
            return {    
                zone : [],
                zoneTable : [],
                add : true,
                map:{},
                mapboxgl:{},
                i:65,
                nbZone:0,
                idZone:0,
                longitude:0,
                latitude:0,
                questions:{},
                newquestions:{},
                newquestionsPark:{},
                reponse:{
                    next:[{
                        idr:0,
                        type:"Question",
                        intitule:"",
                        next:{},
                    }],
                },
                markerTable:[],
                idr:1,
                PVReady :1,
            };
        },
        mounted: function(){
            const token = this.token;
            const GoogleMap = require("@googlemaps/js-api-loader");
            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries:["geometry","marker"],
            });

            this.longitude = this.site.longitude;
            this.latitude =this.site.latitude;
            this.idZone=this.site.id;
            this.add =true;

            if(this.pvready == 1){
                this.questions = JSON.parse(JSON.parse(this.formulaire).building);
                this.newquestions = JSON.parse(JSON.parse(this.formulaire).building);
                this.newquestionsPark = JSON.parse(JSON.parse(this.formulaireParking).building);
            }
            
            this.PVReady=this.pvready;
            this.zone = this.zoneexistant;
            this.zoneTable = this.zoneexistant;
            this.i=this.zoneexistant.length+65;
            this.nbZone = this.zoneexistant.length;

            loader.load().then(() => {
                this.map = new google.maps.Map(document.querySelector("#map"), {
                    center: { lat: this.latitude, lng: this.longitude },
                    zoom: 16,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    tilt: 0,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    mapId: "90f87356969d889c"
                });

                const HTMLMarker = require("./maps/HTMLMarker");

                this.zoneexistant.forEach(element=>{
                    var marker = new HTMLMarker.default(element["latitude"], element["longitude"], element['nom']);
                    marker.setMap(this.map);
                });

            });
            

        },
        methods :{
            addZone(){
                this.add = false;

                this.zone.push({
                    "name":"",
                    "nom":String.fromCharCode(this.i),
                    "longitude":this.site.longitude,
                    'latitude':this.site.latitude,
                    "roof":{},
                    'zone_ID':this.idZone, 
                    'CoeffPVReady': 1,
                    'comments':""
                })

                // A marker with a with a URL pointing to a PNG.
                const markerSiteImg = document.createElement('img');
                markerSiteImg.src = '/image/maps/marker_blue.png';

                // Initiate base position marker
                const siteMarkerBase = new google.maps.marker.AdvancedMarkerElement({
                    position: { lng: this.longitude, lat: this.latitude },
                    map,
                    gmpDraggable: false,
                    content: markerSiteImg,
                    title:"Site marker",
                });
                
                // A marker with a with a URL pointing to a PNG.
                const markerBuildingImg = document.createElement('img');
                markerBuildingImg.src = '/image/maps/marker_red.png';

                // Initiate draggable marker
                const buildingMarker = new google.maps.marker.AdvancedMarkerElement({
                    position: { lng: this.longitude, lat: this.latitude },
                    map,
                    gmpDraggable: true,
                    content: markerBuildingImg,
                    title:"Building marker"
                });

                var label = String.fromCharCode(this.i);
                this.i++;
                this.nbZone++;

                google.maps.event.addListener(buildingMarker, 'dragend', (e) => {
                    var long = document.getElementById("longitude"+label);
                    long.value = e.latLng.lng();
                    this.zone[this.zone.length-1]["longitude"] = e.latLng.lng();

                    var lati = document.getElementById("latitude"+label);
                    lati.value = e.latLng.lat();
                    this.zone[this.zone.length-1]["latitude"] = e.latLng.lat();
                });

                this.markerTable.push(buildingMarker);
            },
            back(){
                 document.getElementById("back").submit();
            },
            saveZone(){
                this.add = true;
                this.zoneTable.push(this.zone[this.zone.length-1]);
                if(this.PVReady==1){
                    if(this.zone[this.zone.length-1]["name"] == "Parking") {
                        this.zone[this.zone.length-1]["roof"]= JSON.stringify(this.questionsPark);
                        this.questionsPark=this.newquestionsPark;

                    } else {
                        this.zone[this.zone.length-1]["roof"]= JSON.stringify(this.questions);
                        this.questions=this.newquestions;
                    }
                }else{
                    this.zone[this.zone.length-1]["roof"] = "{}"
                }
                this.markerTable[this.markerTable.length-1].setDraggable(false);

                const HTMLMarker = require("./maps/HTMLMarker");
                const lng = this.markerTable[this.markerTable.length-1].getPosition().lng();
                const lat = this.markerTable[this.markerTable.length-1].getPosition().lat();

                var marker = new HTMLMarker.default(lat, lng, this.zone[this.zone.length-1]['nom']);
                marker.setMap(this.map);

                this.markerTable.push(marker);
                document.getElementById('data').value = JSON.stringify(this.zone[this.zone.length-1]);
                document.getElementById("savezone").submit();
            },
            save(){
            
                this.longitude = document.getElementById("longitudeLabel").textContent;
                this.latitude = document.getElementById("latitudeLabel").textContent;
                document.getElementById("latitude").value= this.latitude;
                document.getElementById("zone_ID").value= this.idZone;
                document.getElementById("longitude").value= this.longitude;
                document.getElementById('name').value = this.type;
                document.getElementById("addzone").submit();
            },
            updateQuestionsQuestionnaire() {
                if(this.zone[this.zone.length-1]["name"] == "Parking" ) {
                    this.questions = this.newquestionsPark;
                } else {
                    this.questions = this.newquestions;
                }
            }

        }

    }

</script>
